import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  width: '100%',
};

export const grid: SxStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const stack: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const expandedContent: SxStyle = {
  borderWidth: 4,
  borderStyle: 'solid',
  borderRadius: (p) => p.spacing(1),
  padding: (p) => p.spacing(1.5, 2),
  mt: 1,
};

export const detailRow = (index: number): SxStyle => ({
  padding: (p) => p.spacing(1),
  backgroundColor: (p) => (index % 2 === 0 ? '#FCFAFF' : p.palette.primary[50]),
  borderRadius: (p) => p.spacing(0.5),
});
